export const Action = {
  auth: {
    login: 'auth/login',
    logout: 'auth/logout',
    check: 'auth/check',
    refreshToken: 'auth/refreshToken'
  },
  device: {
    load: 'device/load',
    load_all: 'device/load_all'
  },
  inventory: {
    loadDevices: 'inventory/loadDevices'
  }
}